import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function AboutSipo() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="40756" id="who-this-is-for" ref={sectionRef} className="bg-muted py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {}
          <div className={cn("relative col-span-1 lg:col-span-6 h-full min-h-[400px] w-full transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12")}>
            <div className="relative h-full w-full overflow-hidden rounded-sm">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_unboxing_lifestyle.png" alt="Professional watch unboxing experience" className="h-full w-full object-cover object-center" />
              {}
              <div className="absolute inset-0 bg-black/5 pointer-events-none" />
            </div>
          </div>

          {}
          <div className={cn("col-span-1 lg:col-span-5 lg:col-start-8 flex flex-col justify-center transition-all duration-1000 ease-out delay-200 transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12")}>
            <div className="flex flex-col gap-6">
              <div className="flex gap-6">
                {}
                <div className="w-1 shrink-0 bg-primary self-stretch rounded-full" />
                
                <h2 className="text-[52px] leading-[1.1] font-sans font-normal text-foreground tracking-tight">
                  Tailored for Industry Leaders
                </h2>
              </div>

              <p className="text-[18px] leading-[1.6] text-muted-foreground pl-7">
                We specialize in high-precision manufacturing for micro-brands, influencer 
                private labels, and premium corporate gifting. Our turnkey solutions 
                bridge the gap between initial design and professional, market-ready 
                results that elevate your brand's presence in the global market.
              </p>

              <div className="pt-4 pl-7">
                <Button asChild variant="secondary" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-base font-semibold shadow-sm">
                  <Link to="/CollectionPage" aria-label="View our watch collection">
                    View The Collection
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}